import { useState } from "react";
import { Box, Button, Typography, makeStyles } from "@material-ui/core";
import { Chart } from "chart.js";
import { useEffect, useRef } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import TopChartDetailsModal from "./TopChartDetailsModal";

const CHART_COLOR = "#1b5c7e";

const useStyles = makeStyles({
  card: {
    backgroundColor: themeColorsDesingSystem.background.main,
    borderRadius: 4,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    padding: "1.25rem",
    height: 350,
    minHeight: 350,
    maxHeight: 350,
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "0.75rem",
    marginBottom: "1rem",
  },
  title: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: themeColorsDesingSystem.gray.dark,
    textAlign: "left",
    flex: 1,
  },
  detailsButton: {
    textTransform: "none",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: themeColorsDesingSystem.primary.main,
    padding: "4px 8px",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: themeColorsDesingSystem.stone.light,
    },
  },
  chartContainer: {
    flex: 1,
    minHeight: 250,
    position: "relative",
  },
});

export default function CardTopUsersAccessChart({ data = [], details = [] }) {
  const classes = useStyles();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!chartRef.current || !data.length) return;

    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");

    chartInstance.current = new Chart(ctx, {
      type: "bar",
      data: {
        labels: data.map((item) => item.Usuario),
        datasets: [
          {
            label: "Quantidade de Acessos",
            data: data.map((item) => item.QuantidadeAcesso),
            backgroundColor: CHART_COLOR,
            borderColor: CHART_COLOR,
            borderRadius: 4,
            barPercentage: 0.5,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
          callbacks: {
            label: (context) => `Acessos: ${context.yLabel ?? context.raw}`,
          },
        },
        scales: {
          yAxes: {
            beginAtZero: true,
            gridLines: {
              color: themeColorsDesingSystem.stone.light,
              borderDash: [3, 3],
              drawBorder: false,
            },
            ticks: {
              fontSize: 10,
              fontColor: themeColorsDesingSystem.gray.main,
            },
          },
          xAxes: [
            {
              gridLines: { display: false },
              ticks: {
                fontSize: 9,
                fontColor: themeColorsDesingSystem.gray.main,
                maxRotation: 45,
                minRotation: 45,
              },
            },
          ],
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <>
      <Box className={classes.card}>
        <Box className={classes.header}>
          <Typography className={classes.title}>
            Acessos - Top 10 usuários
          </Typography>
          <Button
            className={classes.detailsButton}
            onClick={() => setModalOpen(true)}
            disabled={!details.length}
          >
            <VisibilityIcon fontSize="small" />
          </Button>
        </Box>
        <Box className={classes.chartContainer}>
          <canvas ref={chartRef} />
        </Box>
      </Box>

      <TopChartDetailsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Detalhes - Top 10 usuários"
        variant="users"
        usersDetails={details}
      />
    </>
  );
}
